/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatetimeInterval
 */
export interface DatetimeInterval {
    /**
     * 
     * @type {string}
     * @memberof DatetimeInterval
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof DatetimeInterval
     */
    endingAt: string;
}

export function DatetimeIntervalFromJSON(json: any): DatetimeInterval {
    return DatetimeIntervalFromJSONTyped(json, false);
}

export function DatetimeIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatetimeInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
    };
}

export function DatetimeIntervalToJSON(value?: DatetimeInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
    };
}

